export default {
  addToCart: 'Add to basket',
  addOns: 'Add-ons',
  availability: 'Availability',
  availabilityDaySelector: 'Availability date selector',
  capacity: 'Capacity',
  checkout: 'Checkout',
  continue: 'Continue',
  findAvailability: 'Find Availability',
  from: 'from',
  night: 'night',
  nights: 'nights',
  noAvailableSessionsForSelectedDates:
    'Some dates in your selection do not have available sessions. Please select different dates.',
  loading: 'Loading',
  noAvailableSessionsOnThisDate: 'No available sessions on this date',
  noCollectionFound: 'No collection found!',
  noData: 'No data!',
  noGroupAvailableOnThisDateAndTime:
    'No {{groupTitle}} available at this date and time',
  noResourceGroupFound: 'No resource group found!',
  people: 'people',
  person: 'person',
  priceTierRadioGroup: 'Price tier radio group',
  questions: 'Questions',
  reserve: 'Reserve',
  reserveNow: 'Reserve now',
  select: 'Select',
  selectTime: 'Select time',
  session: 'Session',
  showLess: 'Show less',
  showMore: 'Show more',
  tier: 'Tier',
  time: 'Time',
  total: 'Total',
  unavailable: 'Unavailable',
  viewDetails: 'View details',
  whatsIncluded: "What's included",
  dateRangeSelector: 'Date range selector',
  startTime: 'Start time',
  duration: 'Duration',
  lengthOfStay: 'Length of stay',
  startDate: 'Start date',
  endDate: 'End date',
  selectDates: 'Select dates',
  more: 'More',
  selectStartTime: 'Select a start time',
  endTime: 'End time',
  morning: 'Morning',
  save: 'Save',
  afternoon: 'Afternoon',
  selectEndTime: 'Select an end time',
  selectDuration: 'Select a duration',
  forLength: 'for {{length}}',
  bookedByDay: 'Booked by the day',
  bookedByNight: 'Booked by the night',
  moreDates: '{{count}} more',
  addDate: 'Add date',
  start: 'Start',
  end: 'End',
  pickupFrom: 'Pickup from',
  returnBy: 'Return by',
  day: 'day',
  days: 'days',
  hour: 'hour',
  hours: 'hours',
};
